﻿

$(document).ready(function () {

    var customerNumber = getCurrentCustomerNumber();
    setDropdownToCurrentCustomer(customerNumber);

    $("#weigh-in-subcustomer-list").on("change",
        function() {
            var subcustomerCustomerNumber = $("#weigh-in-subcustomer-list option:selected").val();
            var url = $("#weigh-in-subcustomer-number").attr("href") + subcustomerCustomerNumber;
            console.log(url);
            window.location = url;
        });
});

function getCurrentCustomerNumber() {
    var currentQueryString = gro.modules.url.getUrlParam("subcustomerCustomerNumber");
    if (!currentQueryString.length)
        currentQueryString = $("#weigh-in-subcustomer-list option:first").val();

    return currentQueryString;
}

function setDropdownToCurrentCustomer(customerNumber) {
    $("#weigh-in-subcustomer-list").val(customerNumber);
}
